export const JOIN_LIVE_RUNTIME_ROUTE = "/app/join-live-session/open";

export function buildJoinedLiveSessionRoute({
  code,
  participantName,
  runtimeKind,
} = {}) {
  const searchParams = new URLSearchParams();

  if (code) {
    searchParams.set("code", code);
  }

  if (participantName) {
    searchParams.set("participantName", participantName);
  }

  if (runtimeKind) {
    searchParams.set("runtimeKind", runtimeKind);
  }

  const search = searchParams.toString();

  return search
    ? `${JOIN_LIVE_RUNTIME_ROUTE}?${search}`
    : JOIN_LIVE_RUNTIME_ROUTE;
}

export function parseJoinedLiveSessionRoute(search = "") {
  const searchParams = new URLSearchParams(search);

  return {
    code: searchParams.get("code") || "",
    participantName:
      searchParams.get("participantName") || "",
    runtimeKind:
      searchParams.get("runtimeKind") || "",
  };
}
